import script from "./ModuleManage.vue?vue&type=script&setup=true&lang=js"
export * from "./ModuleManage.vue?vue&type=script&setup=true&lang=js"

import "./ModuleManage.vue?vue&type=style&index=0&id=428a678c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-428a678c"]])

export default __exports__